export default __webpack_public_path__ + "static/media/FranklinGothicURWCom-Boo.0d20f89d.ttf";